import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "m-filter-group" }
const _hoisted_2 = {
  class: "m-filter-group__icon",
  ref: "icon",
  width: "16",
  height: "9",
  viewBox: "0 0 16 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M8 0.5C8.28125 0.5 8.53125 0.59375 8.71875 0.78125L14.7188 6.78125C15.125 7.15625 15.125 7.8125 14.7188 8.1875C14.3438 8.59375 13.6875 8.59375 13.3125 8.1875L8 2.90625L2.71875 8.1875C2.34375 8.59375 1.6875 8.59375 1.3125 8.1875C0.90625 7.8125 0.90625 7.15625 1.3125 6.78125L7.3125 0.78125C7.5 0.59375 7.75 0.5 8 0.5Z" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  class: "m-filter-group__content",
  ref: "content"
}
const _hoisted_6 = {
  class: "m-filter-group__content-container",
  ref: "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TpxCheckboxGroup = _resolveComponent("TpxCheckboxGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "m-filter-group__heading",
      tabIndex: "0",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["enter"]))
    }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4, 512))
    ], 32),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_TpxCheckboxGroup, {
          tooltip: _ctx.tooltip,
          checkboxes: _ctx.checkboxes,
          "onUpdate:checkboxes": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkboxes) = $event)),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('change')))
        }, null, 8, ["tooltip", "checkboxes"])
      ], 512)
    ], 512)
  ]))
}